module.exports = "<div id=\"map\"></div>\r\n"